import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import ClientsPage from "./pages/ClientsPage";
import InvoicesPage from "./pages/InvoicesPage";
import CreateInvoicePage from "./pages/CreateInvoicePage";
import BulkGeneratePage from "./pages/BulkGeneratePage";
import TemplatesPage from "./pages/TemplatesPage";
import TemplateBuilderPage from "./pages/TemplateBuilderPage";
import PocketbookInvoicePage from "./pages/PocketbookInvoicePage";
import PocketbookWisePage from "./pages/PocketbookWisePage";
import RedmineTasksPage from "./pages/RedmineTasksPage";
import JiraTasksPage from "./pages/JiraTasksPage";
import SettingsPage from "./pages/SettingsPage";
import Layout from "./components/Layout";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      } />
      <Route path="/register" element={
        <PublicRoute>
          <RegisterPage />
        </PublicRoute>
      } />
      <Route path="/" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="invoices/new" element={<CreateInvoicePage />} />
        <Route path="invoices/bulk" element={<BulkGeneratePage />} />
        <Route path="invoices/:id/edit" element={<CreateInvoicePage />} />
        <Route path="templates" element={<TemplatesPage />} />
        <Route path="templates/:templateId/build" element={<TemplateBuilderPage />} />
        <Route path="templates/build" element={<TemplateBuilderPage />} />
        <Route path="pocketbook-invoice" element={<PocketbookInvoicePage />} />
        <Route path="pocketbook-wise" element={<PocketbookWisePage />} />
        <Route path="redmine-tasks" element={<RedmineTasksPage />} />
        <Route path="jira-tasks" element={<JiraTasksPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster 
          position="top-right" 
          richColors 
          closeButton
          toastOptions={{
            style: {
              fontFamily: 'IBM Plex Sans, sans-serif',
            },
          }}
        />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
